import { offsetParent } from "./offset-parent";
export var isBodyOffset = function (element) { return (offsetParent(element) === element.ownerDocument.body); };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/is-body-offset.js
// module id = 765
// module chunks = 93